<template>
    <div class="sec-cont">
        <Head :title="title"/>
        <div class="max-w-full bg-white rounded-md shadow overflow-hidden p-6">
            <form @submit.prevent="submitForm">

                <!-- Applicant Details Section -->
                <h2 class="text-xl font-bold mb-4">Ticket System</h2>

                <div class="flex flex-wrap -mb-8 -mr-6">

                    <div class="pb-4 pr-6 w-full lg:w-full">
                        <label class="form-label">{{ __('Ticket') }}</label>
                        <div class="mt-2 mb-2 flex items-center">
                            <div class="mr-6">
                                <input type="radio" id="student" value="student" name="ticket_type"
                                       v-model="form.ticket_type"
                                       class="mr-2"
                                />
                                {{ __('Student') }}
                            </div>
                            <div>
                                <input type="radio" id="staff" value="staff" name="ticket_type"
                                       v-model="form.ticket_type"
                                       class="mr-2"
                                />
                                {{ __('Staff') }}
                            </div>
                        </div>
                        <span v-if="form.errors.ticket_type" class="text-red-500">{{
                                form.errors.ticket_type
                            }}</span>
                    </div>

                    <text-input v-if="form.ticket_type=='student'" v-model="form.student_name"
                                :error="form.errors.student_name"
                                class="pb-4 pr-6 w-full lg:w-1/3" :label="__('Student Name')"
                    />


                    <text-input v-if="form.ticket_type=='staff'" v-model="form.student_name"
                                :error="form.errors.student_name"
                                class="pb-4 pr-6 w-full lg:w-1/3" :label="__('Staff Name')"
                    />


                    <text-input v-model="form.subject" :error="form.errors.subject"
                                class="pb-4 pr-6 w-full lg:w-1/3" :label="__('Subject')"
                    />

                    <select-input v-model="form.priority" :error="form.errors?.priority"
                                  class="pb-4 pr-6 w-full lg:w-1/3" :label="__('Priority')"
                    >
                        <option v-for="(label, code) in ticket_priorities" :value="label" :key="label">
                            {{ label }}
                        </option>
                    </select-input>

                    <div class="pb-4 pr-6 w-full lg:w-1/3">
                        <multi-select-input2 id="assigned-to"
                                             :label="__('Assigned to')"
                                             v-model="selectedAssignedUsers"
                                             :error="formErrors.user"
                                             :options="users"
                                             required
                        />
                    </div>


                    <select-input v-if="form.staff=='staff'" v-model="form.users"
                                  :error="form.errors?.staff"
                                  class="pb-4 pr-6 w-full lg:w-1/3" :label="__('Select Staff')"
                    >
                        <option v-for="(label, code) in users" :value="label.id" :key="code">
                            {{ label.first_name + ' ' + label.last_name }}
                        </option>
                    </select-input>

                    <text-input v-if="form.ticket_type=='student'" v-model="form.father_name"
                                :error="form.errors.father_name"
                                class="pb-4 pr-6 w-full lg:w-1/2" :label="__('Father\'s Name')"
                    />

                    <select-input v-if="form.ticket_type=='student'" v-model="form.education_level"
                                  :error="form.errors?.education_level"
                                  class="pb-4 pr-6 w-full lg:w-1/3" :label="__('Class')" required="true"
                    >
                        <option v-for="(label, code) in education_levels" :value="label" :key="label">
                            {{ label }}
                        </option>
                    </select-input>

                    <select-input v-if="form.ticket_type=='student'" v-model="form.section"
                                  :error="form.errors?.sections"
                                  class="pb-4 pr-6 w-full lg:w-1/3" :label="__('Section')" required="true"
                    >
                        <option v-for="(label, code) in sections" :value="label" :key="label">
                            {{ label }}
                        </option>
                    </select-input>

                    <select-input v-if="form.ticket_type =='student' && (form.education_level=='11th Standard' || form.education_level=='12th Standard') " v-model="form.stream"
                                  :error="form.errors?.streams"
                                  class="pb-4 pr-6 w-full lg:w-1/3" :label="__('Stream')"
                    >
                        <option v-for="(label, code) in streams" :value="label" :key="label">
                            {{ label }}
                        </option>
                    </select-input>


                    <text-input v-model="form.contact_number" :error="form.errors.contact_number"
                                class="pb-4 pr-6 w-full lg:w-1/3"
                                :label="__('Contact Number')" type="number"
                    />

                    <text-input v-model="form.email_address" :error="form.errors.email_address"
                                class="pb-4 pr-6 w-full lg:w-1/3" :label="__('Email address')"
                    />


                    <select-input v-model="form.department" :error="form.errors?.department"
                                  class="pb-4 pr-6 w-full lg:w-1/3" :label="__('Department')"
                    >
                        <option value="" selected>{{ __('Department') }}</option>
                        <option v-for="(label, code) in departments" :value="code" :key="code">
                            {{ label }}
                        </option>
                    </select-input>


                    <div class="pb-4 pr-6 w-full lg:w-1/3">
                        <multi-select-input2 id="cc"
                                             :label="__('CC')"
                                             v-model="selectedCcUsers"
                                             :error="formErrors.user"
                                             :options="users"
                                             required
                        />
                    </div>


                    <section class="s__2 w-full lg:w-full">
                        <span class="form-label">{{ __('Description') }}</span>
                        <div v-if="!form.editDescription" class="prose pt-4 text-sm cursor-pointer"
                             @click="toggleDetails()" v-html="form.description || 'Add more details...'"
                        ></div>
                        <section v-if="form.editDescription">
                            <quill-editor ref="editDescription" @ready="onEditorReady" class="task__description"
                                          v-model:content="form.description" :options="editorOptions" contentType="html"
                                          theme="snow"
                            />
                        </section>
                    </section>

                    <div class="pb-4 pr-6 mt-4 w-full lg:w-full">
                        <div class="file-upload-container">

                            <div v-for="(document, index) in documentUploads" :key="index" class="mb-6 lg:w-1/2">
                                <h3 class="font-bold mb-2">Upload Document {{ index + 1 }}</h3>

                                <!-- FilePond for Drag and Drop -->
                                <file-pond
                                    type="file"
                                    name="documents"
                                    label-idle="Drag & Drop your files or <span class='filepond--label-action'>Browse</span>"
                                    allow-multiple="false"
                                    ref="pond"
                                    @change="fileAdded($event, index)"
                                    @removefile="removeFile( this.documentUploads[index].name)"
                                    v-show="!document.uploaded"
                                >
                                </file-pond>

                                <!-- Input for Document Name -->
                                <label for="documentName" class="block font-bold mb-2">Document Name:</label>
                                <input
                                    id="documentName"
                                    v-model="document.name"
                                    name="document_names[]"
                                    type="text"
                                    class="form-input w-full"
                                    placeholder="Enter document name"
                                />

                                <!-- Preview of the selected file -->
                                <div v-if="document.preview" class="mt-4">
                                    <h4 class="font-bold mb-2">Document Preview:</h4>
                                    <img v-if="isImage(document.preview)" :src="document.preview" alt="Preview"
                                         class="w-1/2"
                                    />
                                    <a v-else :href="document.preview" target="_blank" class="text-blue-500 underline">
                                        {{ document.name }} (Click to preview)
                                    </a>
                                </div>

                                <!-- Add Document Button -->
                                <button
                                    v-if="document.selectedFile"
                                    class="btn btn-success mt-4"
                                    @click.prevent="uploadDocument(index)"
                                >
                                    Add Document
                                </button>

                                <div v-if="document.uploaded" class="mt-4">
                                    <p class="text-green-600">Document {{ document.name }} uploaded successfully!</p>
                                </div>
                            </div>

                            <!-- Button to Add More Document Upload Fields -->
                            <button type="button" class="btn btn-primary mt-4" @click="addMoreDocument">
                                Add More Document
                            </button>

                            <!-- Display Uploaded Documents -->
                            <div v-if="uploadedDocuments.length > 0" class="mt-4">
                                <h3 class="font-bold">Uploaded Documents:</h3>
                                <ul>
                                    <li v-for="(doc, index) in uploadedDocuments" :key="index">
                                        {{ doc.name }} - {{ doc.path }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>


                </div>
                <!-- Submit Button -->
                <div class="flex items-center justify-center px-8 py-4 bg-gray-50 border-t border-gray-100 mt-8">
                    <loading-button :loading="form.processing" class="btn-indigo mx-auto" type="submit">{{
                            __('Submit')
                        }}
                    </loading-button>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import AcademicQualifications from '@/Pages/Interview/AcademicQualifications'
import axios from 'axios'
import moment from 'moment'
import {QuillEditor} from '@vueup/vue-quill'
import Icon from '@/Shared/Icon'
import Loader from '@/Shared/Loader'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import 'moment-duration-format'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import MultiSelectInput from '@/Shared/MultiSelectInput2'
import MultiSelectInput2 from '@/Shared/MultiSelectInput2'


const FilePond = vueFilePond()
export default {

    components: {
        MultiSelectInput2,
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
        AcademicQualifications,
        QuillEditor,
        Icon,
        Loader, Datepicker, FilePond,
        MultiSelectInput,
    },
    layout: Layout,
    props: {
        education_levels:
            {
                type: Object,
                required: true, // This ensures that applicant should be provided
            },
        users:
            {
                type: Object,
                required: true, // This ensures that applicant should be provided
            },
        sections: {
            type: Object,
            required: true, // This ensures that applicant should be provided
        },
        streams:
            {
                type: Object,
                required: true, // This ensures that applicant should be provided
            },
        ticket_priorities:
            {
                type: Object,
                required: true, // This ensures that applicant should be provided
            },
        departments:
            {
                type: Object,
                required: true, // This ensures that applicant should be provided
            },
        staff_list:
            {
                type: Object,
                required: true, // This ensures that applicant should be provided
            },
    },
    data() {
        return {
            documentUploads: [
                {
                    selectedFile: null,
                    name: '',
                    uploaded: false,
                    preview: null,
                    fileItem: null,
                },
            ],
            selectedDepartments: [],
            selectedAssignedUsers:[],
            selectedCcUsers:[],
            formErrors: {
                department: null,
            },
            uploadedDocuments: [],
            form: this.$inertia.form({
                ticket_type:'',
                subject: '',
                priority: '',
                staff: '',
                assigned_users: [],
                cc_users: [],
                student_name: '',
                father_name: '',
                education_level: '',
                section: '',
                stream: '',
                contact_number: '',
                description: '',
                email_address: '',
                department: '',
                editDescription: true,
                errors: {},
                processing: false,
            }),
            ticket_priority: {
                1: 'Highest',
                2: 'Medium',
                3: 'Low',
            },
            staff_list: {
                1: 'user 1',
                2: 'user 2',
                3: 'user 3',
            },
            task: {},
            currentDate: new Date().toISOString().split('T')[0], // to set the max date
            editorOptions: {
                modules: {
                    toolbar: {
                        container: [
                            {'header': [1, 2, 3, 4, 5, 6, false]},
                            'bold', 'italic', 'underline', {'list': 'bullet'}, {'list': 'ordered'},
                            'align', 'clean',
                            'blockquote', 'code-block',
                            // 'image'
                        ],
                        // handlers: { 'image': this.imageButtonClickHandler }
                    },
                    // imageDrop: true,
                },
            },
        }
    },
    watch:{
        selectedAssignedUsers(newSelectedUsers) {
            this.updateAssignedUsers(newSelectedUsers);
        },
        selectedCcUsers(newSelectedUsers) {
            this.updateCcUsers(newSelectedUsers);
        },
    },
    methods: {
        openNewChecklist() {
            this.newCheckList = true
            const ref = this.$refs.ncl
            setTimeout(function () {
                ref.focus()
            }, 0)
        },
        updateAssignedUsers(selectedUsers) {
            // Map the selected users into the required structure
            this.form.assigned_users = selectedUsers.map(user => ({
                user_id: user.id,
                assignment_type: 'assigned',  // You can customize this based on your needs
            }));
            console.log(this.users);
            console.log("users list");
        },

        updateCcUsers(selectedUsers) {
            // Map the selected users into the required structure
            this.form.cc_users = selectedUsers.map(user => ({
                user_id: user.id,
                assignment_type: 'cc',  // You can customize this based on your needs
            }));
        },

        async imageButtonClickHandler() {
            const input = document.createElement('input')
            input.setAttribute('type', 'file')
            input.click()
            input.onchange = async () => {
                const file = input.files[0]
                this.$refs.form.editDescription.focus()
            }

        },
        async get_average_rgb(src) {
            return new Promise(resolve => {
                let context = document.createElement('canvas').getContext('2d')
                context.imageSmoothingEnabled = true
                let img = new Image()
                img.src = src
                img.crossOrigin = ''
                img.onload = () => {
                    context.drawImage(img, 0, 0, 1, 1)
                    resolve(context.getImageData(0, 0, 1, 1).data.slice(0, 3))
                }
            })
        },
        async makeCover(task, attachment) {
            task.cover = attachment
            await this.saveTask({cover: attachment.id})
            this.$refs.t__cover.style.backgroundColor = await this.bgColor(task.cover.path)
        },
        removeCover(task) {
            this.saveTask({cover: null})
            task.cover = null
        },
        toggleDetails() {
            this.form.editDescription = true
            this.$refs.form.editDescription.focus()
        },
        onEditorReady(editor) {
            editor.focus()
        },
        deleteAttachment(id, index) {
            if (this.task.cover && (this.task.cover.id === id)) {
                this.task.cover = null
            }
            axios.post(this.route('task.attachment.delete', id), {}).then((response) => {
                if (response.data) {
                    this.task.attachments.splice(index, 1)
                }
            })
        },
        async uploadAttachment(e, is_comment) {
            e.preventDefault()
            if (!e.target.files.length) {
                return
            }
            const file = e.target.files[0]
            if (this.task.is_demo && (file.size / 1024) / 1024 > 2) {
                alert('Uploading file size less than 2MB is not allowed in the demo mode!')
                return
            }
            const obj = await this.uploadFile(file)
            if (obj && obj.error) {
                alert('Please upload image, video, doc/pdf/text/ai/figma file formats only!')
            } else {
                this.task.attachments.push(obj)
                if (is_comment) {
                    const name = ['jpeg', 'png', 'gif', 'jpg', 'svg', 'webp', 'bmp'].includes(obj.name.split('.').pop()) ? `<img src="${obj.path}" alt="${obj.name}" />` : `${obj.name}`
                    const link = `<br/><a href="${obj.path}" target="_blank">${name}</a><br/>`
                    this.new_comment.details = this.new_comment.details || '' + link
                }
            }
        },
        async uploadFile(file) {
            let formData = new FormData()
            formData.append('file', file)
            const resp = await axios.post(this.route('task.attachment.add', this.task.id), formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            return resp.data
        },
        goToLink(link) {
            window.location.href = link
        },
        saveList(project_id, taskObject) {
            axios.post(this.route('task.update.list', project_id), taskObject).catch((error) => {
                console.log(error)
            })
        },
        getSelectedList() {
            let listItem = this.list_items.filter(l => {
                return l.id === this.move_object.list_id && l.project_id === this.move_object.project_id
            })
            if (!listItem.length) {
                listItem = this.list_items.filter(l => l.project_id === this.move_object.project_id)
                this.move_object.list_id = listItem[0].id
            }
            return listItem[0]
        },
        getSelectedProjectLists() {
            return this.list_items.filter(l => l.project_id === this.move_object.project_id)
        },
        getSelectedListPostions() {
            return this.getSelectedList().id === this.task.list_id ? parseInt(this.getSelectedList().tasks_count, 10) : parseInt(this.getSelectedList().tasks_count, 10) + 1
        },
        getSelectedProject() {
            return this.projects.filter(p => p.id === this.move_object.project_id)[0]
        },
        displayMoveCard() {
            this.move_object.project_id = this.task.project.id
            this.move_object.list_id = this.task.list.id
            this.move_object.order = this.task.order
            this.showMoveCard = true
        },
        searchLabel(input) {
            return this.labels.filter(lab => lab.name.toLowerCase().indexOf(input) > -1)
        },
        searchTag(input) {
            return this.tags.filter(lab => lab.name.toLowerCase().indexOf(input) > -1)
        },
        searchUser(input) {
            return this.team_members.filter(tm => tm.user.name.toLowerCase().indexOf(input) > -1)
        },
        deleteLabel(id) {
            axios.post(this.route('labels.delete', id)).catch((error) => {
                console.log(error)
            })
            const findIndex = this.labels.findIndex(l => l.id === id)
            this.labels.splice(findIndex, 1)
            const tlIndex = this.task.task_labels.findIndex(tl => tl.label_id === id)
            if (tlIndex > -1) {
                this.task.task_labels.splice(tlIndex, 1)
            }
            this.label = {}
        },
        saveLabel(labelObject) {
            axios.post(this.route('labels.save'), labelObject).then((response) => {
                if (response.data && !labelObject.id) {
                    this.labels.push(response.data)
                } else if (labelObject.id) {
                    const findIndex = this.labels.findIndex(l => l.id === labelObject.id)
                    const tlIndex = this.task.task_labels.findIndex(tl => tl.label_id === labelObject.id)
                    this.labels[findIndex] = labelObject
                    if (tlIndex > -1) {
                        this.task.task_labels[tlIndex]['label'] = labelObject
                    }
                }
                this.showEditLabelBox = false
                this.showLabelBox = true
                this.showTagBox = true
            }).catch((error) => {
                console.log(error)
            })
            this.label = {}
        },
        addLabelToTask(checked, id) {
            axios.post(this.route('task.labels.add'), {task_id: this.task.id, label_id: id}).then((response) => {
                if (response.data) {
                    if (checked) {
                        this.task.task_labels.push(response.data)
                    } else {
                        const findIndex = this.task.task_labels.findIndex(tl => tl.label_id === id)
                        if (findIndex > -1) {
                            this.task.task_labels.splice(findIndex, 1)
                        }
                    }
                }
            }).catch((error) => {
                console.log(error)
            })
        },
        assignUserToTask(checked, id) {
            axios.post(this.route('task.assignees.add'), {task_id: this.task.id, user_id: id}).then((response) => {
                if (response.data) {
                    if (checked) {
                        this.task.assignees.push(response.data)
                        if (response.data.id && response.data.user && response.data.user.id) {
                            this.sendNotification('send.mail.task_user_added', response.data.id, response.data.user.id)
                        }
                    } else {
                        const findIndex = this.task.assignees.findIndex(a => a.user_id === id)
                        if (findIndex > -1) {
                            this.task.assignees.splice(findIndex, 1)
                        }
                    }
                }
            }).catch((error) => {
                console.log(error)
            })
        },
        followUserToTask(checked, id) {
            axios.post(this.route('task.assignees.add'), {task_id: this.task.id, user_id: id}).then((response) => {
                if (response.data) {
                    if (checked) {
                        this.task.followers.push(response.data)
                        if (response.data.id && response.data.user && response.data.user.id) {
                            this.sendNotification('send.mail.task_user_added', response.data.id, response.data.user.id)
                        }
                    } else {
                        const findIndex = this.task.followers.findIndex(a => a.user_id === id)
                        if (findIndex > -1) {
                            this.task.followers.splice(findIndex, 1)
                        }
                    }
                }
            }).catch((error) => {
                console.log(error)
            })
        },
        task_label_ids() {
            return this.task.task_labels.map(item => item.label_id)
        },
        task_assignees() {
            return this.task.assignees.map(item => item.user_id)
        },
        task_followers() {
            return this.task.followers.map(item => item.user_id)
        },
        saveDetails() {
            if (this.task.description) {
                const desc = this.task.description
                this.saveTask({description: desc})
            }
        },
        async deleteTask() {
            await axios.post(this.route('task.delete', this.task.id), {})
            this.goToLink(this.route(this.view === 'table' ? 'projects.view.table' : 'projects.view.board', this.task.project_id))
        },
        saveTask(taskObject) {
            axios.post(this.route('task.update', this.task.id), taskObject).then((response) => {
                if (response.data) {
                    this.sendNotification('send.mail.task_update', response.data.id)
                }
            })
        },
        checklistDoneCount(checkList) {
            return checkList.filter(item => !!item.is_done).length
        },
        modifyCheck(check_list) {
            check_list.modify = true
            setTimeout(() => {
                document.getElementById('modify_' + check_list.id).focus()
            }, 10)
        },
        deleteCheckList(id, index, checkLists) {
            axios.post(this.route('check_list.delete', id)).catch((error) => {
                console.log(error)
            })
            checkLists.splice(index, 1)
        },
        deleteComment(id, index, comments) {
            axios.post(this.route('comment.delete', id)).catch((error) => {
                console.log(error)
            })
            comments.splice(index, 1)
        },
        modifyCheckListSubmit(check_list, c_index, checklist) {
            if (!check_list.title) {
                this.deleteCheckList(check_list.id, c_index, checklist)
            } else {
                this.saveCheckList(check_list.id, {title: check_list.title})
            }
            check_list.modify = false
        },
        inputNewChecklistAction(check_list, e) {
            if ((e && e.keyCode === 13) || !e) {
                if (!check_list.title) {
                    this.newCheckList = false
                } else {
                    this.saveNewCheckList({title: check_list.title, task_id: this.task.id}, this.task.checklists)
                    this.openNewChecklist()
                }
            }
        },
        saveCheckList(id, checkListObject) {
            axios.post(this.route('check_list.update', id), checkListObject).catch((error) => {
                console.log(error)
            })
        },
        saveComment(id, commentObject) {
            axios.post(this.route('comment.update', id), {details: commentObject.details}).catch((error) => {
                console.log(error)
            })
        },
        saveNewCheckList(checkListObject, currentCheckList) {
            this.new_chek_list.title = ''
            axios.post(this.route('check_list.new'), checkListObject).then((response) => {
                if (response.data) {
                    currentCheckList.push(response.data)
                }
            }).catch((error) => {
                console.log(error)
            })
        },
        saveNewComment(commentObject, currentComments) {
            this.new_comment.details = ''
            commentObject.created_at = this.moment().format('YYYY/MM/DD HH:mm:ss')
            axios.post(this.route('comments.new'), commentObject).then((response) => {
                if (response.data) {
                    currentComments.push(response.data)
                    this.showCommentBox = false
                    this.sendNotification('send.mail.comment', response.data.id)
                }
            }).catch((error) => {
                console.log(error)
            })
        },
        sendNotification(uri, id, user_id) {
            const data = {id}
            if (!!user_id) {
                data.user_id = user_id
            }
            axios.post(this.route(uri, data)).catch((error) => {
                console.log(error)
            })
        },
        async getTask(id) {
            const taskResponse = await axios.get(this.route('json.task.get', id))
            if (Object.keys(taskResponse.data).length) {
                this.task = await taskResponse.data
                this.counter.timer = this.task.timer || null
                if (this.counter.timer && (this.counter.timer.task_id === this.task.id)) {
                    this.startTimer()
                }
                this.loading = false
                await this.getOtherData()
            } else {
                alert('something went wrong')
            }
        },
        saveTitle(e) {
            if (e.keyCode === 13 || e.type === 'blur') {
                e.preventDefault()
                e.target.blur()
                if (e.target.innerText) {
                    const title = e.target.innerText
                    axios.post(this.route('task.update', this.task.id), {title}).then((response) => {
                        if (response.data) {
                            this.sendNotification('send.mail.task_update', response.data.id)
                        }
                    })
                }
            }
        },
        async getOtherData() {
            const dataResponse = await axios.get(this.route('task.other.data', {
                task_id: this.task.id,
                project_id: this.task.project_id,
            }))
            const res = dataResponse.data
            this.labels = res.labels || []
            this.tags = res.tags || []
            this.list_items = res.lists || []
            this.projects = res.projects || []
            this.team_members = res.team_members || []
            this.existing_timer = res.timer || null
            this.counter.duration = res.duration || 0
            this.move_object.order = this.task.order
            if (this.task.cover && this.$refs.t__cover) {
                this.$refs.t__cover.style.backgroundColor = await this.bgColor(this.task.cover.path)
            }
        },
        addMoreDocument() {

            // Add a new document upload field to the array
            this.documentUploads.push({
                selectedFile: null,
                name: '',
                uploaded: false,
                preview: null,
            })
        },
        fileAdded(fileItem, index) {
            // FilePond passes the file object directly as part of fileItem.file
            const file = fileItem.target.files[0]

            // Store the selected file for the specific document upload section
            this.documentUploads[index].selectedFile = file
            this.documentUploads[index].fileItem = fileItem

            // Generate a preview for image files or other supported types
            if (file) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.documentUploads[index].preview = e.target.result
                }
                reader.readAsDataURL(file) // Read the file and generate a preview
            }
        },
        async uploadDocument(index) {
            const file = this.documentUploads[index].selectedFile
            const documentName = this.documentUploads[index].name

            if (!file || !documentName) {
                alert('Please enter a document name and select a file before uploading.')
                return
            }

            await this.handlePhotoChange({file}, documentName)  // Pass the file object directly
        },
        async removeFile(fileName) {
            console.log('fileName is ' + fileName)
            const filePath = this.uploadedFiles[fileName]
            if (!filePath) return

            try {
                const formData = new FormData()
                formData.append('filePath', filePath)
                formData.append('user_id', this.applicant.id)

                await axios.post(this.route('document.remove'), formData)

                // Clear local state
                this.uploadedFiles[fileName] = null
                this.form[fileName] = null
                console.log('File removed successfully from server')
            } catch (error) {
                console.error('Error removing file from server:', error)
            }
        },
        submitForm() {
            this.form.processing = true
            this.form.post(this.route('admin.storeTicket'), {
                onSuccess: () => {
                },
            })
        },
        isImage(fileUrl) {
            // Check if the file is an image by its MIME type
            return fileUrl && fileUrl.startsWith('data:image')
        },
    },
    created() {
        this.moment = moment
    },

}
</script>
